var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossInCircleLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cross-in-circle 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verify-email",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.000000, -30.000000)",
    fill: "#FFFFFF",
    id: "cross-in-circle-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross-in-circle-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross-in-circle"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,28 C21.7319864,28 28,21.7319864 28,14 C28,6.2680135 21.7319864,0 14,0 C6.2680135,0 0,6.2680135 0,14 C0,21.7319864 6.2680135,28 14,28 Z M14,25.4545455 C7.67382923,25.4545455 2.54545455,20.3261707 2.54545455,14 C2.54545455,7.67382923 7.67382923,2.54545455 14,2.54545455 C20.3261707,2.54545455 25.4545455,7.67382923 25.4545455,14 C25.4545455,20.3261707 20.3261707,25.4545455 14,25.4545455 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99188408,9.70848863 L18.2915114,20.0081159 C18.7655386,20.4821432 19.5340887,20.4821432 20.0081159,20.0081159 C20.4821432,19.5340887 20.4821432,18.7655386 20.0081159,18.2915114 L9.70848863,7.99188408 C9.23446137,7.51785682 8.46591134,7.51785682 7.99188408,7.99188408 C7.51785682,8.46591134 7.51785682,9.23446137 7.99188408,9.70848863 Z",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.294416,7.99138572 L7.99138572,18.294416 C7.51802294,18.7677788 7.51802294,19.5352515 7.99138572,20.0086143 C8.4647485,20.4819771 9.2322212,20.4819771 9.70558398,20.0086143 L20.0086143,9.70558398 C20.4819771,9.2322212 20.4819771,8.4647485 20.0086143,7.99138572 C19.5352515,7.51802294 18.7677788,7.51802294 18.294416,7.99138572 Z",
    id: "Line"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossInCircleLarge);
export default __webpack_public_path__ + "static/media/CrossInCircleLARGE.6b576b19228822066614aa723075dfc2.svg";
export { ForwardRef as ReactComponent };